// extracted by mini-css-extract-plugin
export var lg = "_gg-7";
export var md = "_gg-6";
export var placeholderContainer = "_gg-1";
export var placeholderIcon = "_gg-2";
export var productImage = "_gg-0";
export var sm = "_gg-5";
export var xl = "_gg-8";
export var xs = "_gg-4";
export var xxs = "_gg-3";